export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./password.forgot.vue?vue&type=template&id=fdbed908&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/password/password.forgot.vue?vue&type=template&id=fdbed908&scoped=true&
// module id = 744
// module chunks = 4